import { concat } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton, PrismCard, PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { Illustration } from 'frontend-utils';
import { DOMAIN_NAME } from 'frontend-utils/utils/constants/domain-utils';
import MyAndMarketOtbIllustration from 'lumen/assets/images/upsell/my-and-market-otb.svg?raw';
import MyOtbIllustration from 'lumen/assets/images/upsell/my-otb.svg?raw';
import GeneralButtonsOtbSelfServiceButton from 'lumen/components/general/buttons/otb-self-service-button';
import GeneralEmptyStateDataValidation from 'lumen/components/general/empty-state-data-validation';
import hasFeature from 'lumen/helpers/has-feature';
import { getTranslationKeysForBanner } from 'lumen/utils/components/general/empty-state-otb-banner';
import {
  OTB_SS_ENTRY_POINTS,
  OTB_SS_VIA_QP_VALUES,
} from 'lumen/utils/constants/otb-selfservice-constants';

import styles from './empty-state-occupancy.module.css';

interface HotelOverviewDashboardTilesTopInsightsEmptyStateOccupancySignature {
  Args: {};
}

export default class HotelOverviewDashboardTilesTopInsightsEmptyStateOccupancy extends Component<HotelOverviewDashboardTilesTopInsightsEmptyStateOccupancySignature> {
  @service declare myotbSs: Services['myotb-ss'];

  <template>
    {{#if (hasFeature "otb.empty_placeholder")}}
      <div class="prism-card--occupancy">
        <section class={{styles.eso-banner}}>
          <div class="flex flex-row">
            <Illustration
              @html={{if
                (hasFeature "otb.market_benchmark_eligible")
                MyAndMarketOtbIllustration
                MyOtbIllustration
              }}
              class={{styles.illustration}}
            />

            <div class="flex flex-col">
              <div class="flex flex-wrap items-center">
                {{#let
                  (getTranslationKeysForBanner
                    OTB_SS_ENTRY_POINTS.OD_OCCUPANCY
                    (hasFeature "otb.market_benchmark_eligible")
                  )
                  as |translationKeys|
                }}
                  <h4 class={{styles.title}}>
                    {{! @glint-expect-error: translationKeys.title exists }}
                    {{t translationKeys.title}}
                  </h4>
                  <span
                    class="eso__banner-content paragraph-300--regular mt-100"
                  >
                    {{t translationKeys.message}}
                  </span>
                {{/let}}

                <a
                  class="eso__banner-link text-300--regular mt-200 mb-400 flex flex-row items-center gap-100"
                  href={{concat
                    "https://help."
                    DOMAIN_NAME
                    "/en/articles/4086741-add-your-otb-data-to-ota-insight"
                  }}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {{t "overview_dashboard.otb_ss.empty_state.link"}}
                  <PrismIcon @name="link-out" @size="small" />
                </a>
              </div>

              <div>
                <span class="flex flex-row items-center gap-300">
                  <GeneralButtonsOtbSelfServiceButton
                    @otbSelfServiceEntryPoint={{OTB_SS_ENTRY_POINTS.OD_OCCUPANCY}}
                    @otbSelfServiceEntryProduct={{OTB_SS_VIA_QP_VALUES.OVERVIEW_DASHBOARD}}
                  />
                  <PrismButton
                    @buttonType="secondary"
                    @label={{t "general.dismiss"}}
                    @onClick={{this.myotbSs.onOtbSelfServiceClose}}
                  />
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    {{else if (hasFeature "otb.data_validation")}}
      <PrismCard
        @contentLayout="noPadding"
        class="prism-card--od-kpi prism-card--occupancy"
      >
        <:content>
          <GeneralEmptyStateDataValidation />
        </:content>
      </PrismCard>
    {{/if}}
  </template>
}
